import { ELanguage } from '@microfrontends/react-components'
import { decodeBase64 } from '../helpers/encode'

export const DEFAULT_SUCCESS_CODE = 200
export const DEFAULT_ERROR_CODE = 400

type TCompanyBenefit = {
    benefitDescription: string
    benefitId: number
    benefitName: string
}

export type TCLPInfo = {
    companyBenefit: TCompanyBenefit[]
    companyBranchAddress: string
    companyOfficeImage: string[]
    headquaterAddress: string
}

export interface ICompanyInfo {
    companyId: number
    address: string
    bannerDesktopUri: string
    clpInfo: TCLPInfo | null
    companyBenefits: TCompanyBenefit[]
    companyLogoURL: string
    companyName: string
    companySlug?: string
    companyProfile: string
    companySizeId: number
    contactEmail: string
    contactName: string
    jobImageURLs: string[]
    jobVideoURLs: string[]
    profileBaseName: string
    website: string
    whyWorkWithUs: string
    industries: {
        industryId: number
        industryName: string
        industryNameVI: string
    }[]
    industriesV3: {
        industryV3Id: number
        industryV3Name: string
        industryV3NameVI: string
    }[]
    companySizeName: string
    isFollowed: number
    totalFollow: number
    totalJobs?: number
    followerCount?: number
    profilePublishedSiteMask?: number
    companyNameCCP?: string
    companyLogoUrlCCP?: string
    industriesCCP?: {
        industryId: number
        industryName: string
        industryNameVI: string
    }[]
    onlineJobCount?: number
    jobs?: any[]
}

const COMPANY_DETAIL_API =
    process.env.NEXT_PUBLIC_MS_BASE_PATH +
    '/company-profile/v1.0/company-profile/detail'
const COMPANY_FOLLOW_API = `${process.env.NEXT_PUBLIC_MS_BASE_PATH}/api-gateway/v1.0/profile/follow`
export interface ICompanyDetailResponse {
    meta: {
        code: number
        message: string
    }
    data: ICompanyInfo | null
}

export const companyDetailService = async (data: {type: string, id: string}, userId?: number, langCode?: ELanguage): Promise<ICompanyDetailResponse> => {
    try {
        const body = {
            userId: userId,
            [data.type]: Number(data.id)
        }

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': langCode || ELanguage.VI
            },
            body: JSON.stringify(body)
        }
        const responseCompanyDetail = await fetch(COMPANY_DETAIL_API, requestOptions)
        return await responseCompanyDetail.json()
    } catch (err) {
        return {
            meta: {
                code: DEFAULT_ERROR_CODE,
                message: 'ERROR'
            },
            data: null
        }
    }
}

export interface ICompanyFollowResponse {
    meta?: {
        code: number
        message: string
    }
    data: any
    code?: number
    id?: number
    message?: string
}

export const companyFollow = async (companyId: number, isFollow: boolean, accessToken: string, langCode: ELanguage): Promise<ICompanyFollowResponse> => {
    try {
        const postData = {
            companyId: companyId,
            status: isFollow ? 1 : 0
        }
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': langCode || ELanguage.VI,
                Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify(postData)
        }
        const response = await fetch(COMPANY_FOLLOW_API, requestOptions)
        return await response.json()
    } catch (err) {
        console.error(err)
        return {
            meta: {
                code: DEFAULT_ERROR_CODE,
                message: 'ERROR'
            },
            data: null
        }
    }
}
